/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BookingInfoModalQueryVariables = {
    bookingId?: string | null | undefined;
    date?: string | null | undefined;
};
export type BookingInfoModalQueryResponse = {
    readonly lastBookingStatus: {
        readonly bookingStatus: string | null;
        readonly lastBooking: string | null;
    } | null;
};
export type BookingInfoModalQuery = {
    readonly response: BookingInfoModalQueryResponse;
    readonly variables: BookingInfoModalQueryVariables;
};



/*
query BookingInfoModalQuery(
  $bookingId: String
  $date: String
) {
  lastBookingStatus(bookingId: $bookingId, date: $date) {
    bookingStatus
    lastBooking
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      },
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      }
    ],
    "concreteType": "LastBookingStatus",
    "kind": "LinkedField",
    "name": "lastBookingStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastBooking",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingInfoModalQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookingInfoModalQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1bbd36ca002cb14e652bf27460bb5676",
    "id": null,
    "metadata": {},
    "name": "BookingInfoModalQuery",
    "operationKind": "query",
    "text": "query BookingInfoModalQuery(\n  $bookingId: String\n  $date: String\n) {\n  lastBookingStatus(bookingId: $bookingId, date: $date) {\n    bookingStatus\n    lastBooking\n  }\n}\n"
  }
};
})();
(node as any).hash = '50acf4c03263f1fcba9ed2210f2f9294';
export default node;
